import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { RouterLink } from '@angular/router';
import { AirportPickerComponent } from '../../airport-picker/airport-picker.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-enquiry-cotation-edit-modal-content',
    templateUrl: './enquiry-cotation-edit-modal-content.component.html',
    styleUrls: ['./enquiry-cotation-edit-modal-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, RouterLink, AirportPickerComponent, FaIconComponent, DatePipe, TranslateModule]
})
export class EnquiryCotationEditModalContentComponent {
  faTrash = faTrash;

  @Input() form: FormGroup;
  @Input() enquiry: any;
  @Input() currentOffer: any;
  @Input() currentCotation: any;
  @Input() airlinesAircrafts: any;
  @Input() itinerariesList: any[] = [];
  @Input() legsList: any = {};
  @Input() legsObj: any = {};
  @Input() airportsObj: any = {};
  @Input() defaultCurrency: any;
  @Input() todayCurrencyExchangeRate: any;

  @Input() EnumEnquiryType: any;
  @Input() EnumAcmiType: any;

  @Input() getCountryLabel: (countryCode: string) => string;
  @Input() getDefaultCurrency: () => string;
  @Input() getCurrencies: () => string[];
  @Input() getEnumCurrencySymbol: (currency: string) => string;
  @Input() getEnumCurrencyLabel: (currency: string) => string;

  @Input() saveCotation: (...args: any[]) => any;
  @Input() updateItineraryIdOfCotation: (...args: any[]) => any;
  @Input() updateLegsId: (...args: any[]) => any;
  @Input() updatedCurrency: (...args: any[]) => any;
  @Input() updatedValue: (...args: any[]) => any;
  @Input() updateTaxesByPersonType: (...args: any[]) => any;
  @Input() updatedTaxesByPersonByLeg: (...args: any[]) => any;
  @Input() updatedTaxesByPersonByAirport: (...args: any[]) => any;
  @Input() updateByPersonIncludedField: (...args: any[]) => any;
  @Input() setValueToFormControl: (...args: any[]) => any;
  @Input() removeAcmiRouting: (...args: any[]) => any;
  @Input() acmiDatesInMonth: (...args: any[]) => any;
}
